import { useEffect, useState } from "react";
// import TabContext from "@mui/lab/TabContext";
import { Grid } from "@mui/material";
// import Tab from "@mui/material/Tab";
import SubmittedImg from "../../../assets/images/submittedimg.svg";
// import Tabs from "@mui/lab/TabList";
// import TabPanel from "@mui/lab/TabPanel";
import { toast } from "react-toastify";
import PageTitle from "../../../components/PageTitle";
import Modal from "../../../components/Modal";
import useStyles from "../styles";
// import Button from "../../../components/Button";
import NoExamFound from "../../../assets/images/noexam.svg";
import StudentExaminationCard from "../components/StudentExaminationCard";
import { httprequest } from "../../../data/api";
import PageLoader from "../../../components/PageLoader";

const STUDENT_EXAM = "/api/v1/school-exams/student";

const ApplicantExamination = () => {
  const classes = useStyles();
  // const [value, setValue] = useState("");
  const [submittedModal, setSubmittedModal] = useState(false);
  const [noExamModal, setNoExamModal] = useState(false);
  const [exams, setExams] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // const handleTabChange = (event, newValue) => {
  //   setValue(newValue);
  // };

  /**
 * Toggles the submitted modal's visibility state
 * @function handleSubmittedModal
 */
  const handleSubmittedModal = () => {
    setSubmittedModal(!submittedModal);
  };

  /**
 * Fetches all available exams for the applicant from the server
 * @function getAllApplicantExam
 * @async
 * @returns {Promise<void>}
 * @description Retrieves the list of exams and updates the state, handles loading states and errors
 */
  const getAllApplicantExam = () => {
    setIsLoading(true);
    httprequest.get(STUDENT_EXAM).then((res) => {
      setExams(res?.data?.data);
      setIsLoading(false);
    }).catch((err) => {
      setIsLoading(false);
      toast.error(err.response.data);
    });
  };

  /**
 * Effect hook to fetch all applicant exams when component mounts
 * @effect
 * @listens Mount
 * @description Calls getAllApplicantExam on component initialization
 */
  useEffect(() => {
    getAllApplicantExam();
  }, []);

  /**
 * Toggles the no exam modal's visibility state
 * @function handleNoExamModal
 */
  const handleNoExamModal = () => {
    setNoExamModal(!noExamModal);
  };

  return (
    <div className={`${classes.border} page-content`}>
      <PageTitle
        title="All Examinations accessible to you"
        subtitle="These are all the examinations you can take"
        // button={
        //   <div className="flex gap-10">
        //     <Button onClick={handleNoExamModal} variant="primary" buttonSize="fluid" color="btndefault" buttonName="Check for Exam" />
        //   </div>
        // }
      />
      <div className="page-content height-full">
        <Grid container spacing={2}>
          {isLoading ? (
            <div className="padding-top-56 margin-auto">
              <PageLoader />
            </div>
          ) : (
            <>
              {exams && exams.length > 0 ? (
                exams.map((exam, index) => {
                  // const exam_id = exam?.exam_id || exam?.subject?.id;

                  return (
                    <Grid item lg={4} md={6} sm={12} xs={12} key={index}>
                      <StudentExaminationCard
                        examtitle={exam?.subject?.name}
                        examdesc={exam?.description || "Attempt this Exam"}
                        duration={`${exam?.duration || "duration"} mins`}
                        examlink={`/student-examination/${exam?.subject?.id}`}
                        status={exam?.status}
                      />
                    </Grid>
                  );
                })
              ) : (
                <div className={classes.noexamcont}>
                  <div className={classes.noexamimg}>
                    <img src={NoExamFound} alt="Not Found" />
                  </div>
                  <div>
                    <p className={classes.nocodeheader}>No Examination Found</p>
                    <p className={classes.nocodesentence}>The school admin has not uploaded any exam for you to see.</p>
                  </div>
                </div>
              )}
            </>
          )}
        </Grid>
        {/* <ToastContainer /> */}
        {/* <div className="pagination-container">
          <Pagination count={totalPages} page={currentPage} onChange={handlePageChange} variant="outlined" shape="rounded" color="primary" />
        </div> */}
      </div>
      {/* Exam Submitted MOdal */}
      <Modal
        title="Great Job"
        subtitle=""
        modalContent={
          <>
            <div>
              <div className={classes.forerrorimg}>
                <img src={SubmittedImg} alt="Submitted Image" />
              </div>
              <div>
                <p className={classes.nocodeheader}>Your exam has been submitted</p>
                <p className={classes.nocodesentence}>Go to the result section to see your result</p>
              </div>
            </div>
          </>
        }
        modalFooter={
          <>
          </>
        }
        isopen={submittedModal}
        closeModal={handleSubmittedModal}
      />
      {/* No Exam Found MOdal */}
      <Modal
        title="Check For Your Exam"
        subtitle=""
        modalContent={
          <>
            <div>
              <div className={classes.noexamimg}>
                <img src={NoExamFound} alt="Not Found" />
              </div>
              <div>
                <p className={classes.nocodeheader}>No Examination Found</p>
                <p className={classes.nocodesentence}>The school admin has not uploaded any exam for you to see.</p>
              </div>
            </div>
          </>
        }
        modalFooter={
          <>
          </>
        }
        isopen={noExamModal}
        closeModal={handleNoExamModal}
      />
    </div>
  );
};

export default ApplicantExamination;
